import { render, staticRenderFns } from "./CambiarAsiento.vue?vue&type=template&id=01b0b312"
import script from "./CambiarAsiento.vue?vue&type=script&lang=js"
export * from "./CambiarAsiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports